import {
  checkSubscriptionResource,
  hasUserSubscriptedIdealPlan,
} from 'common/subscription/checkSubscriptionResource';
import Divider from 'design-system/components/Divider/Divider';
import { Icon } from 'design-system/components/Icon';
import dynamic from 'next/dynamic';
import { ComponentPropsWithoutRef, useContext } from 'react';
import { DocumentDetailContext } from 'state/document/DocumentDetailProvider';
import { twMerge } from 'tailwind-merge';
import LibraryMaterialDetailReadySection from '../components/LibraryMaterialDetailReadySection';
import DocumentDetailMainSection from './components/DocumentDetailMainSection';

const LibraryMaterialDetailUpgradePlanSection = dynamic(
  () => import('../components/LibraryMaterialDetailUpgradePlanSection')
);

type DocumentDetailSidebarProps = ComponentPropsWithoutRef<'div'> & {};

const DocumentDetailSidebar = (props: DocumentDetailSidebarProps) => {
  const { latestSubscription, document } = useContext(DocumentDetailContext);

  const hasUserSubscriptedIdealPlanValue =
    hasUserSubscriptedIdealPlan(latestSubscription) ||
    document?.material.isOwner;

  const doesUserHasAccessToDocument =
    checkSubscriptionResource(latestSubscription).document.accessToDocument ||
    document?.material?.isOwner;

  return (
    <div
      {...props}
      className={twMerge(
        'sticky left-0 top-[70px] mt-4 h-fit w-[350px]',
        'space-y-[10px]'
      )}
    >
      {doesUserHasAccessToDocument && (
        <LibraryMaterialDetailReadySection
          icon={<Icon iconName={'done'} size={32} />}
        />
      )}
      <div
        style={{
          background: !hasUserSubscriptedIdealPlanValue
            ? 'linear-gradient(180deg, #FFF 0%, #FFF9E9 100%)'
            : '',
        }}
        className={twMerge(
          'flex h-fit flex-col gap-6 rounded-lg bg-white p-6 xl:border xl:shadow-elevator2',
          props.className,
          hasUserSubscriptedIdealPlanValue
            ? 'border-Success/Border'
            : 'border-Other/OutlinedUpgradedborder-stroke'
        )}
      >
        {!hasUserSubscriptedIdealPlanValue && (
          <>
            <LibraryMaterialDetailUpgradePlanSection />
            <Divider />
          </>
        )}
        <DocumentDetailMainSection />
      </div>
    </div>
  );
};

export default DocumentDetailSidebar;
